let playbtns = document.querySelectorAll('.play-btn');
playbtns.forEach((data) => {
    data.addEventListener("click", (singledata) => {
        let btntarget = singledata.currentTarget;
        btntarget?.nextElementSibling?.classList.add("active");
    })
})

let closebtn = document.querySelectorAll('.close');
closebtn.forEach((data) => {
    data.addEventListener("click", (closedata) => {
        let closetarget = closedata.currentTarget;
        closetarget.parentElement.classList.remove("active");
    })
})

let navbtn = document.querySelectorAll('.nav-content-wrapper');
navbtn.forEach((data) => {
    data.addEventListener("click", (navdata) => {
        let navtarget = navdata.currentTarget;
        navtarget.classList.toggle('active');
    })
})